import React from 'react';

interface BackendIconProps extends React.SVGProps<SVGSVGElement> {}

export const BackendIcon = ({ width = 89, height = 102, ...props }: BackendIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 89 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#filter0_f_272_449)">
      <ellipse cx="34.5" cy="4.5" rx="34.5" ry="4.5" transform="matrix(1 0 0 -1 10 92)" fill="#4444FF"/>
    </g>
    <g filter="url(#filter1_d_272_449)">
      <path d="M36.7589 26.3269C27.6114 30.5924 22.3946 38.1144 24.8828 43.4503L32.4899 59.7638C34.9781 65.0997 44.0935 65.9385 53.241 61.6729C62.3884 57.4074 67.6052 49.8854 65.117 44.5496L57.5099 28.236C55.0217 22.9001 45.9063 22.0614 36.7589 26.3269ZM58.5945 37.6606C59.3568 39.2954 58.7951 41.5868 57.0554 43.9476C55.0963 46.6052 51.9404 49.0389 48.1695 50.7972C44.3987 52.5556 40.5059 53.4088 37.2107 53.2014C34.284 53.0166 32.1676 51.9739 31.4053 50.3392L30.0867 47.5115C34.1744 48.7086 39.8952 48.0353 45.6338 45.3594C51.3725 42.6834 55.5624 38.727 57.276 34.833L58.5945 37.6606ZM29.1408 35.8954C31.1 33.2378 34.2559 30.8042 38.0267 29.0458C41.7975 27.2875 45.6904 26.4342 48.9855 26.6417C51.9122 26.8265 54.0287 27.8691 54.791 29.5039C55.5533 31.1386 54.9915 33.4301 53.2519 35.7909C51.2927 38.4484 48.1368 40.8821 44.366 42.6404C40.5952 44.3988 36.7023 45.2521 33.4071 45.0446C30.4804 44.8598 28.364 43.8172 27.6017 42.1824C26.8394 40.5477 27.4011 38.2562 29.1408 35.8954ZM60.859 52.1044C58.8999 54.762 55.7439 57.1956 51.9731 58.954C48.2023 60.7123 44.3094 61.5656 41.0143 61.3581C38.0876 61.1733 35.9712 60.1307 35.2089 58.496L33.8903 55.6683C37.978 56.8654 43.6988 56.1921 49.4374 53.5161C55.176 50.8402 59.3659 46.8838 61.0795 42.9897L62.3981 45.8174C63.1604 47.4522 62.5987 49.7436 60.859 52.1044Z" fill="white"/>
    </g>
    <g opacity="0.3">
      <path d="M69 15C69 17.7614 71.2386 20 74 20C71.2386 20 69 22.2386 69 25C69 22.2386 66.7614 20 64 20C66.7614 20 69 17.7614 69 15Z" fill="white"/>
      <path d="M23 59C23 62.866 26.134 66 30 66C26.134 66 23 69.134 23 73C23 69.134 19.866 66 16 66C19.866 66 23 62.866 23 59Z" fill="white"/>
    </g>
    <defs>
      <filter id="filter0_f_272_449" x="0" y="73" width="89" height="29" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_272_449"/>
      </filter>
      <filter id="filter1_d_272_449" x="14.2632" y="13.6074" width="61.4734" height="60.785" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0 1 0 0 0 1 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_272_449"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_272_449" result="shape"/>
      </filter>
    </defs>
  </svg>
);

